import React, { ComponentProps } from 'react';
import { useNavigate } from 'react-router';
import { asView } from '../../../_lib/ViewFetcher';
import IForm from '../../../types/IForm';
import { ContentParagraph, ContentParagraphModifier } from '../../../_lib/components/ContentParagraph';
import LiveRegion from '../../../components/atoms/LiveRegion/LiveRegion';
import Form, { FormContainerModifier, FormTemplate } from '../../../components/molecules/Form';
import { FormSubmitButton } from '../../../components/molecules/Form/components/FormSubmitButton/FormSubmitButton';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type TransformPageTypeDefaultProps = { form?: IForm };

function TransformPageTypeDefault({ form }: TransformPageTypeDefaultProps) {
  const { t } = useSonTranslation('TransformPageType');
  const navigate = useNavigate();
  if (!form) {
    return (
      <div className="transform-page-type-form">
        <ContentParagraph modifier={ContentParagraphModifier.MARGIN_BOTTOM}>
          {t('declineTransformationExplanation.paragraph1')}
        </ContentParagraph>
        <ContentParagraph modifier={ContentParagraphModifier.MARGIN_BOTTOM}>
          <ul className="transform-page-type-form__list">
            <li>{t('declineTransformationExplanation.list.element1')}</li>
            <li>{t('declineTransformationExplanation.list.element2')}</li>
            <li>{t('declineTransformationExplanation.list.element3')}</li>
            <li>{t('declineTransformationExplanation.list.element4')}</li>
          </ul>
        </ContentParagraph>
      </div>
    );
  }
  return (
    <div className="transform-page-type-form">
      <ContentParagraph>{t('transformExplanation.paragraph1')}</ContentParagraph>
      <ContentParagraph modifier={ContentParagraphModifier.MARGIN_BOTTOM}>
        {t('transformExplanation.paragraph2')}
      </ContentParagraph>
      <ul className="transform-page-type-form__list">
        <li>{t('transformExplanation.list.element1')}</li>
        <li>{t('transformExplanation.list.element2')}</li>
        <li>{t('transformExplanation.list.element3')}</li>
      </ul>
      <ContentParagraph modifier={ContentParagraphModifier.MARGIN_BOTTOM}>
        {t('transformExplanation.paragraph3')}
      </ContentParagraph>
      <ContentParagraph modifier={[ContentParagraphModifier.BOLD, ContentParagraphModifier.MARGIN_BOTTOM]}>
        {t('transformExplanation.paragraph4')}
      </ContentParagraph>
      <Form
        id="transform-page-type"
        model={form}
        containerModifier={FormContainerModifier.NO_PADDING}
        onSuccess={() => navigate(0)}
      >
        <FormTemplate>
          {({ getStatus }) => (
            <>
              <FormSubmitButton buttonLabel={t('buttonLabel')} enabled />
              <LiveRegion invisible={false} htmlTag="div">
                {getStatus()}
              </LiveRegion>
            </>
          )}
        </FormTemplate>
      </Form>
    </div>
  );
}

export const TransformPageTypeDefaultView = asView(TransformPageTypeDefault);
export type TransformPageTypeDefaultView = ComponentProps<typeof TransformPageTypeDefaultView>;
